module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card-title', [_c('h3', [_vm._v("Package Details")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Name")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.planData.name) + "\n      ")])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Price")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currencyFormat(_vm.quotationTotalPrice)) + "\n      ")])], 1), _vm._v(" "), (_vm.formAnswer) ? _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Location of Wake")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.formAnswer.form_answers.main_form.deceased_location_of_wake) + "\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Wake Start Date")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.moment(_vm.caseData.wake_start).format('YYYY-MM-DD')) + "\n        ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Wake End Date")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.moment(_vm.caseData.wake_end).format('YYYY-MM-DD')) + "\n        ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Sending Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.caseData.wake_sending_time ? _vm.caseData.wake_sending_time : '-') + "\n        ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Leave Office Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.caseData.leave_office_time ? _vm.caseData.leave_office_time : '-') + "\n        ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Leave Wake Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.caseData.leave_wake_time ? _vm.caseData.leave_wake_time : '-') + "\n        ")])])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Cremation / Burial Time")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [(_vm.caseData.is_preplan) ? _c('span', [_vm._v("\n          N/A (preplan)\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.caseData.leave_funeral_time ? _vm.caseData.leave_funeral_time : '-') + "\n        ")])])], 1)], 1), _vm._v(" "), _c('v-card-title', [_c('h3', [_vm._v("Payment Methods")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticClass: "padded-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "large-radio full-width",
    attrs: {
      "large": ""
    },
    on: {
      "change": _vm.updatePaymentData
    },
    model: {
      value: (_vm.payment_method),
      callback: function($$v) {
        _vm.payment_method = $$v
      },
      expression: "payment_method"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "first-row",
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Credit Card',
      "value": 'credit_card'
    }
  })], 1), _vm._v(" "), (_vm.payment_method === 'credit_card') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Date and Time Client will head down to office",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cc_datetime),
      callback: function($$v) {
        _vm.payment_method_cc_datetime = $$v
      },
      expression: "payment_method_cc_datetime"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Other remarks",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cc_remarks),
      callback: function($$v) {
        _vm.payment_method_cc_remarks = $$v
      },
      expression: "payment_method_cc_remarks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "first-row",
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Cash',
      "value": 'cash'
    }
  })], 1), _vm._v(" "), (_vm.payment_method === 'cash') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cash collected by and amount",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cash_collected_by),
      callback: function($$v) {
        _vm.payment_method_cash_collected_by = $$v
      },
      expression: "payment_method_cash_collected_by"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Other remarks",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cash_remarks),
      callback: function($$v) {
        _vm.payment_method_cash_remarks = $$v
      },
      expression: "payment_method_cash_remarks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "first-row",
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Cheque',
      "value": 'cheque'
    }
  })], 1), _vm._v(" "), (_vm.payment_method === 'cheque') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cheque collected by",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cheque_collected_by),
      callback: function($$v) {
        _vm.payment_method_cheque_collected_by = $$v
      },
      expression: "payment_method_cheque_collected_by"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Other remarks",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_cheque_remarks),
      callback: function($$v) {
        _vm.payment_method_cheque_remarks = $$v
      },
      expression: "payment_method_cheque_remarks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "first-row",
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Internet banking',
      "value": 'internet_banking'
    }
  })], 1), _vm._v(" "), (_vm.payment_method === 'internet_banking') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Date and Time of Transfer",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_ibanking_datetime),
      callback: function($$v) {
        _vm.payment_method_ibanking_datetime = $$v
      },
      expression: "payment_method_ibanking_datetime"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Other remarks",
      "disabled": _vm.closed
    },
    model: {
      value: (_vm.payment_method_ibanking_remarks),
      callback: function($$v) {
        _vm.payment_method_ibanking_remarks = $$v
      },
      expression: "payment_method_ibanking_remarks"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "first-row",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [(_vm.payment_method && !_vm.closed) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "loading": _vm.loading.updatePaymentInfo,
      "disabled": _vm.loading.updatePaymentInfo
    },
    on: {
      "click": _vm.updatePaymentInfo
    }
  }, [_vm._v("\n            Update Payment Info\n          ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-082de682","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatables/CasePlanDataTable.vue
// module id = 949
// module chunks = 1